"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var notistack_1 = require("notistack");
var react_1 = require("react");
var icons_1 = __importDefault(require("../../../assets/icons"));
var Icon_1 = require("../../atoms/Icon/Icon");
var SnackbarProvider_static_1 = require("./SnackbarProvider.static");
var SnackbarProvider_style_1 = __importDefault(require("./SnackbarProvider.style"));
/**
 * SnackbarProvider provider
 *
 * @description Wrapper component for "SnackbarProvider" from "notistack" notification library
 *
 * {@link https://github.com/iamhosseindhv/notistack Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/providers/SnackbarProvider Source}
 */
var SnackbarProvider = function (_a) {
    var children = _a.children;
    var classes = (0, SnackbarProvider_style_1.default)();
    var ref = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(notistack_1.SnackbarProvider, __assign({ ref: ref, action: function (key) { return ((0, jsx_runtime_1.jsx)(core_1.IconButton, __assign({ onClick: function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.closeSnackbar(key); } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.close, size: SnackbarProvider_static_1.IconSize.lg, color: 'white' }) }))); }, preventDuplicate: true, maxSnack: 3, autoHideDuration: 8000, classes: {
            root: classes.root,
            variantError: classes.content,
            variantInfo: classes.content,
            variantSuccess: classes.content,
            variantWarning: classes.content,
        }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, iconVariant: {
            success: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.success, size: SnackbarProvider_static_1.IconSize.xl, color: 'white', className: classes.icon }),
            error: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.error, size: SnackbarProvider_static_1.IconSize.xl, color: 'white', className: classes.icon }),
            warning: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.warning, size: SnackbarProvider_static_1.IconSize.xl, color: 'white', className: classes.icon }),
        } }, { children: children })));
};
exports.SnackbarProvider = SnackbarProvider;
